import { ProcessingLevel } from "@redotech/cockroachdb-codegen/tables/fulfillment/processing-level";

/** Product processing level. Receiving is CRDB-only; Mongo stores verification/grading. */
export enum ReturnProcessingLevel {
  VERIFICATION = ProcessingLevel.Verification,
  GRADING = ProcessingLevel.Grading,
  RECEIVING = ProcessingLevel.Receiving,
}
